import { render, staticRenderFns } from "./ruleset.vue?vue&type=template&id=59609c8f&scoped=true&"
import script from "./ruleset.vue?vue&type=script&lang=js&"
export * from "./ruleset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59609c8f",
  null
  
)

export default component.exports